import { isFunction } from 'mc-ui-utils';
import constants from '../constants';
import { checkCoachMarkShown } from '../utils/common';
import { hasGlanceInterface, isUserOnline } from '../utils/glanceandroidbridge';
import { hasKhazaddumBridge } from '../utils/khazaddumbridge';
/***
 *  The purpose of this state is to store those global variables which doesnt need to cause rerendering
 */
const glanceStates = {};
const storyStatus = {};
class state {
    constructor() {
        this.isSdk = false;
        this.totalGlances = 0;
        this.isMuted = true;
        this.hasCoachMark = false;
        this.loadedBubbles = new Set();
        this.seenBubles = new Set();
        this.loadedGlances = new Set();
        this.seenGlances = new Set();
        this.interactedGlances = new Set();
        this.isOnline = true;
        this.isSlidePrevented = false;
        this.hasWhatsAppInstalled = true;
        this.disableShare = false;
        this.isShareTrayOpen = false;
        this.impressionMap = {};
        this.registerSDKFunctions = () => {
            this.isOnline = isUserOnline();
            this.hasCoachMark = !checkCoachMarkShown();
            if (hasKhazaddumBridge() &&
                isFunction(window.KhazadDumBridge.registerNetworkChangeCallback)) {
                window.onNetworkStatusChange = (networkStatus) => {
                    this.isOnline = networkStatus;
                };
                window.KhazadDumBridge.registerNetworkChangeCallback('window.onNetworkStatusChange');
            }
            if (hasGlanceInterface() &&
                isFunction(window.GlanceAndroidInterface.isAppInstalled) &&
                !window.GlanceAndroidInterface.isAppInstalled(constants.WHATSAPP_SHARE)) {
                this.hasWhatsAppInstalled = false;
            }
        };
        this.setVideoTimeline = (glanceId, videoTimeline) => {
            glanceStates[glanceId] = Object.assign(Object.assign({}, glanceStates[glanceId]), { videoTimeline });
        };
        this.setStoryDuration = (glanceId, duration) => {
            glanceStates[glanceId] = Object.assign(Object.assign({}, glanceStates[glanceId]), { duration });
        };
        this.setStoryStatus = (glanceIndex, highlightIndex) => {
            storyStatus[glanceIndex] = highlightIndex;
        };
        this.getVideoTimeline = (glanceId) => {
            var _a;
            return (_a = glanceStates[glanceId]) === null || _a === void 0 ? void 0 : _a.videoTimeline;
        };
        this.getVideoDuration = (glanceId) => {
            var _a;
            return (_a = glanceStates[glanceId]) === null || _a === void 0 ? void 0 : _a.duration;
        };
        this.checkGlanceStatesAvailable = (glanceId) => {
            return !!glanceStates[glanceId];
        };
        this.getStoryStatus = (glanceIndex) => storyStatus[glanceIndex];
    }
}
const State = new state();
export default State;
//# sourceMappingURL=index.js.map